import { BoundaryType, Fixity } from '@paragon/contract-library';

import { RootState } from '..';
import { setAnalogJoint, setAnalogLink } from '../slices/componentDesignsSlice';
import { ThunkActionVoid } from './thunkActions';

const getEditedAnalogJoint = (componentDesignGuid: string, guid: string, state: RootState) => {
  const componentDesign = state.componentDesigns.data[componentDesignGuid];
  if (!componentDesign) throw new Error('Could not find component.');
  const { analogModel } = componentDesign;
  if (!analogModel) throw new Error('Could not find analog model.');
  const analogJoint = analogModel.analogJoints.find((item) => item.guid === guid);
  if (!analogJoint) throw new Error('Could not find analog joint.');
  return analogJoint;
};

const getEditedAnalogLink = (componentDesignGuid: string, guid: string, state: RootState) => {
  const componentDesign = state.componentDesigns.data[componentDesignGuid];
  if (!componentDesign) throw new Error('Could not find component.');
  const { analogModel } = componentDesign;
  if (!analogModel) throw new Error('Could not find analog model.');
  const analogLink = analogModel.analogLinks.find((item) => item.guid === guid);
  if (!analogLink) throw new Error('Could not find analog link.');
  return analogLink;
};

export const shiftAnalogJointPosition =
  (componentDesignGuid: string, guid: string, x: number, y: number, z: number): ThunkActionVoid =>
  (dispatch, getState) => {
    const state = getState();
    const analogJoint = getEditedAnalogJoint(componentDesignGuid, guid, state);
    const newAnalogJoint = { ...analogJoint, x: analogJoint.x + x, y: analogJoint.y + y, z: analogJoint.z + z };
    dispatch(setAnalogJoint({ joint: newAnalogJoint, componentDesignGuid, lockAnalog: true }));
  };

export const changeJointBoundaryType =
  (componentDesignGuid: string, guid: string, boundaryType: BoundaryType): ThunkActionVoid =>
  (dispatch, getState) => {
    const state = getState();
    const analogJoint = getEditedAnalogJoint(componentDesignGuid, guid, state);
    const newAnalogJoint = { ...analogJoint, boundaryType };
    dispatch(setAnalogJoint({ joint: newAnalogJoint, componentDesignGuid, lockAnalog: true }));
  };

export const changeLinkFixity =
  (componentDesignGuid: string, guid: string, iFixity: Fixity, jFixity: Fixity): ThunkActionVoid =>
  (dispatch, getState) => {
    const state = getState();
    const analogLink = getEditedAnalogLink(componentDesignGuid, guid, state);
    const newAnalogLink = { ...analogLink, iFixity, jFixity };
    dispatch(setAnalogLink({ link: newAnalogLink, componentDesignGuid, lockAnalog: true }));
  };
